const access_token = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_ACCESS_TOKEN':
            return action.payload;
            break;
        default: 
        	return state;
        	break;
	}
}

export default access_token;